import React from "react"
import {Container, Typography,Divider} from "@mui/material"
import Slider from "react-slick";
import {InsightsTwoTone, AddShoppingCartTwoTone, ApiOutlined, VpnLockOutlined, LanguageOutlined, MobileFriendlyTwoTone} from '@mui/icons-material';
import {makeStyles} from "@mui/styles";
import {createTheme} from "@mui/material/styles"

const theme = createTheme()

const useStyles = makeStyles({
    skill:{
        height:"auto",
        marginBottom:"5rem",
      }

})

const Skill2 = () =>{
    const classes = useStyles()

    var settings = {
        slidesToShow: 3,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 2000,
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
       };
    return(
        <div className={classes.skill}>
        <Container maxWidth="lg" id="services">
          <Typography variant="h4" data-aos="zoom-in-down">Services</Typography>
          <Divider style={{marginBottom:"3rem"}} />
          
            <Slider {...settings}>
            <div>
                <div  style ={{textAlign:"center", color:"#452433"}}>
          <InsightsTwoTone style={{fontSize:"4rem"}} />
          </div>
            <h2 style={{textAlign:"center", marginTop:"1rem"}}> ANALYTICS</h2>
            <p style={{fontSize:"1.2rem", marginTop:"1rem", textAlign:"center", width:"90%"}}>Get insights into who is browsing your site so that you can
                make smarter business decisions
            </p>
            </div>

            <div>
                <div  style ={{textAlign:"center", color:"#D7032A"}}>
          <AddShoppingCartTwoTone style={{fontSize:"4rem"}} />
          </div>
            <h2 style={{textAlign:"center", marginTop:"1rem"}}> ECOMMERCE</h2>
            <p style={{fontSize:"1.2rem", marginTop:"1rem", textAlign:"center", width:"85%"}}>Integration of eCommerce platforms, payment
            gateways, custom product templates, and more
            </p>
            </div>

            <div>
                <div  style ={{textAlign:"center", color:"#2F11D9"}}>
          <MobileFriendlyTwoTone style={{fontSize:"4rem"}} />
          </div>
            <h2 style={{textAlign:"center", marginTop:"1rem"}}> MOBILE-FRIENDLY</h2>
            <p style={{fontSize:"1.2rem", marginTop:"1rem", textAlign:"center", width:"85%"}}>A responsive design makes your website accesssible
            to all users, regardles of their device.
            </p>
            </div>


            <div>
                <div  style ={{textAlign:"center", color:"#061C56"}}>
          <LanguageOutlined style={{fontSize:"4rem"}} />
          </div>
            <h2 style={{textAlign:"center", marginTop:"1rem"}}>WEBSITE AUDITS</h2>
            <p style={{fontSize:"1.2rem", marginTop:"1rem", textAlign:"center", width:"85%"}}>Looking to improve your page
            performance, SEO, or user experience? Request a free site audit
            </p>
            </div>
            

            <div>
                <div  style ={{textAlign:"center", color:"#6BA56D"}}>
          <VpnLockOutlined style={{fontSize:"4rem"}} />
          </div>
            <h2 style={{textAlign:"center", marginTop:"1rem"}}>CONTENT MANAGEMENT</h2>
            <p style={{fontSize:"1.2rem", marginTop:"1rem", textAlign:"center", width:"85%"}}>Custom WordPress theme and plugin
            development. Easily update content without knowing how to code
            </p>
            </div>

            <div>
                <div  style ={{textAlign:"center", color:"#CC7412"}}>
          <ApiOutlined style={{fontSize:"4rem"}} />
          </div>
            <h2 style={{textAlign:"center", marginTop:"1rem"}}>DESIGN + DEVELOPMENT</h2>
            <p style={{fontSize:"1.2rem", marginTop:"1rem", textAlign:"center", width:"85%"}}>Clean, modern designs - optimized
            for performance, search engines, and converting users to customers.
            </p>
            </div>    
              

            </Slider>
        </Container>
        </div>

    )
}

export default Skill2